import { Color } from '@tmh-website/shared/colors';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  a {
    font-weight: ${props => props.theme.fontWeight.medium};
    color: ${props => props.theme.color[Color.Blue_500_Ultramarine]};
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  // Disable text color on iOS devices
  input:is([type="button"], [type="submit"], [type="reset"]), input[type="file"]::file-selector-button, button {
    color: inherit !important;
  }

  .page-wrapper {
    padding-top: ${props => props.theme.headerHeightMobile};
    @media (${props => props.theme.breakpoint.lg.up}) {
      padding-top: ${props => props.theme.headerHeight};
    }
  }
`;

export default GlobalStyles;
